var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-10 col-md-8 mx-auto"},[_c('button',{staticClass:"btn btn-lg btn-block",class:{
      'btn-success': this.$store && !this.$store.getters.isTimerOn && !this.$store.getters.isIntervalCompleted,
      'btn-light': this.$store && !this.$store.getters.isTimerOn && this.$store.getters.isIntervalCompleted,
      'btn-warning': this.$store && this.$store.getters.isTimerOn
    },attrs:{"disabled":this.$store && !this.$store.getters.isTimerOn && this.$store.getters.isIntervalCompleted},domProps:{"innerHTML":_vm._s(_vm.buttonText())},on:{"click":_vm.click}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-308648bf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimerButton.vue
// module id = 90
// module chunks = 1